export default __webpack_public_path__ + "static/news_universal_teaser-56f389fc8ead6d82c4b5cc03fea46aba.png";